export const FETCH_LOYALTY = "loyalty/FETCH_LOYALTY";
export const FETCH_LOYALTY_SUCCESS = "loyalty/FETCH_LOYALTY_SUCCESS";
export const FETCH_LOYALTY_FAIL = "loyalty/FETCH_LOYALTY_FAIL";
export const REDEEM_LOYALTY = "loyalty/REDEEM_LOYALTY";
export const REMOVE_LOYALTY = "loyalty/REMOVE_LOYALTY";
